import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Title: {
    id: 'contacts_title',
    defaultMessage: 'Contact',
  },
  Contacts: {
    id: 'label_contacts',
    defaultMessage: 'Contacts',
  },
  ContactsHelp: {
    id: 'help_contacts',
    defaultMessage: 'Uses contacts set on content if not set here.',
  },
});
